import Reveal, { Eyebrow } from "@/components/Reveal";
import { Scale, ShieldCheck, KeyRound, Landmark } from "lucide-react";

const badges = [
  {
    icon: Scale,
    code: "§",
    title: "Obrigação de meio",
    text: "Empregamos toda a diligência técnica, mas não prometemos prazo ou resultado — quem decide é a Justiça Eleitoral.",
  },
  {
    icon: ShieldCheck,
    code: "48H",
    title: "Descarte de dados",
    text: "Seus documentos são eliminados em até 48h após a conclusão do serviço, conforme a LGPD.",
  },
  {
    icon: KeyRound,
    code: "∅",
    title: "Nunca pedimos sua senha",
    text: "Você mesmo realiza qualquer login ou assinatura no Gov.br — nós apenas orientamos.",
  },
  {
    icon: Landmark,
    code: "CNPJ",
    title: "Empresa formalizada",
    text: "Assessoria prestada por CNPJ ativo, com contrato claro e termo de ciência assinado por você.",
  },
];

export default function TrustSection() {
  return (
    <section id="seguranca" className="bg-ink text-paper py-24 md:py-32 relative overflow-hidden" data-testid="trust-section">
      <span className="pointer-events-none select-none absolute -top-10 right-0 font-serif italic font-bold text-[26vw] leading-none outline-text-light opacity-60">
        Lex
      </span>
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <Reveal>
          <Eyebrow light>Segurança e transparência</Eyebrow>
          <h2 className="font-serif font-semibold text-4xl md:text-5xl tracking-tight text-paper mt-4 max-w-2xl">
            Como protegemos você — e os seus dados.
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-paper/10 border border-paper/10">
          {badges.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.1} className="bg-ink">
              <div className="group h-full p-8 md:p-9 transition-colors duration-500 hover:bg-[#1B2A47]" data-testid={`trust-badge-${i + 1}`}>
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 rounded-full border-[1.5px] border-brass flex items-center justify-center">
                    <b.icon className="w-[18px] h-[18px] text-brass" />
                  </div>
                  <span className="font-mono text-[10px] font-bold tracking-[0.16em] text-brass/70">{b.code}</span>
                </div>
                <h3 className="font-serif font-semibold text-xl text-paper mt-7">{b.title}</h3>
                <p className="text-paper/55 text-[13.5px] leading-relaxed mt-3">{b.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
